import { Align, Arrange, Container, Spacer, Text } from '@loomhq/lens';
import React from 'react';
import { useSelector } from 'react-redux';

import { selectEmojiEnabled } from 'selectors/video';
import { selectVideo } from 'selectors/videoPlayer';

import EndScreenReactionGroup from 'components/ui-components/end-screen-reaction-group';

const EmbedReactionBar = () => {
  const video = useSelector(selectVideo);
  const ownerName = video.owner_name;
  const emojiEnabled = useSelector(selectEmojiEnabled);

  return (
    <div className="theme-dark">
      <Container minHeight="50px" height="50px">
        <Align alignment="center">
          <Arrange justifyContent="center">
            {emojiEnabled && (
              <Text fontWeight="bold">Reply to {ownerName}:</Text>
            )}
            <Spacer left="small" />
            <EndScreenReactionGroup withComment={true} size="small" />
          </Arrange>
        </Align>
      </Container>
    </div>
  );
};

export default EmbedReactionBar;
